const se = {
  se1: { name: 'Erziehen', desc: 'z.B. Kleinkinder, Schulkinder', },
  se2: { name: 'Behandeln', desc: 'z.B. Verletzte, Kranke, Wunden versorgen', },
  se3: { name: 'Pflegen', desc: 'z.B. Patienten, Kranke', },
  se4: { name: 'Unterrichten', desc: 'z.B. Schüler, Auszubildende', },
  se5: { name: 'Trainieren', desc: 'z.B. Sportler, Vereine, Mannschaften', },
  se6: { name: 'Unterstützen', desc: 'z.B. Obdachlose, Migranten, Hilfsbedürftige', },
  se7: { name: 'Therapieren und heilen', desc: 'z.B. Bewegungsapparat, Sprache', },
  se8: { name: 'Beraten', desc: 'z.B. Familien, Eltern, Klienten', },
  se9: { name: 'Betreuen', desc: 'z.B. Jugendliche, Familien, Senioren', },
  se10: { name: 'Versorgen', desc: 'z.B. Pflegebedürftige, Tiere', },
}

export default se



// WEBPACK FOOTER //
// ./src/store/se.js